import { Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPenToSquare } from "@fortawesome/free-solid-svg-icons";
import {
  TableRow,
  NameLink,
  TableDetailCell,
  TableDetailNameCell
} from "../common-styling";
import DeleteButton from "../delete-button";
import NoResultsRow from "../no-results-table-row";
import { deleteKeyword } from "../../services/api-declaration";

const KeywordsTableRow = ({ keywords, fetchKeywords }) => {
  const navigate = useNavigate();
  const generateNavigateLink = (_keywordId) => `${_keywordId}/edit`;
  const navigateToKeyword = (_keywordId) =>
    navigate(generateNavigateLink(_keywordId));

  return keywords.length ? (
    keywords.map((keyword, index) => (
      <TableRow key={index}>
        <TableDetailNameCell
          role="button"
          className="align-middle py-3 text-capitalize"
          onClick={() => navigateToKeyword(keyword.id)}
        >
          <NameLink className="d-block" to={generateNavigateLink(keyword.id)}>
            {keyword.name}
          </NameLink>
        </TableDetailNameCell>
        <TableDetailCell className="py-3 text-end align-middle">
          <div className="d-flex justify-content-end">
            <Button
              size="sm"
              className="me-2 rounded-circle"
              variant="outline-primary"
              onClick={() => navigateToKeyword(keyword.id)}
            >
              <FontAwesomeIcon size="sm" icon={faPenToSquare} />
            </Button>
            <DeleteButton
              variant={"rounded"}
              deleteId={keyword.id}
              onDelete={deleteKeyword}
              onDeleteSuccess={fetchKeywords}
              message={{
                success: "deleteKeywordSuccess",
                confirmation: "deleteKeywordMessage"
              }}
            />
          </div>
        </TableDetailCell>
      </TableRow>
    ))
  ) : (
    <NoResultsRow lengthOfColumns="2" />
  );
};
export default KeywordsTableRow;
